export const INITIAL_DYNAMIC_ATTRIBUTES = Object.freeze({
  button: {
    display: true,
    newPage: true,
  },
  fields: {
    displayImage: true,
    displayTitle: true,
    displayTags: true,
    displayDescription: true,
    displayDate: true,
    displayTextLink: true,
    displayLocation: true,
    displayAttendees: true,
    displayOnlineEvent: true,
  },
  query: {
    numberOfItems: 3,
    dataType: 'last_published',
  },
  singleLine: true,
  type: 'empty',
});
